<div class="tw-flex tw-justify-end tw-gap-2">
  <p-button
    [severity]="dataUrlGenerated ? 'success' : 'secondary'"
    [outlined]="!dataUrlGenerated"
    [icon]="dataUrlGenerated ? 'fas fa-check' : 'fas fa-globe'"
    [label]="dataUrlGenerated ? 'Data URL copied to clipboard!' : 'Generate data URL'"
    (onClick)="dataUrl()"
  />
</div>
<div class="tw-py-4">
  <div class="tw-mb-4">
    <textarea
      pTextarea
      rows="10"
      [formControl]="jsonDataControl"
      class="tw-w-full tw-mt-1 tw-block tw-border tw-border-gray-300 tw-rounded-md tw-shadow-sm"
    ></textarea>
  </div>
  <div
    class="tw-py-4 tw-bg-red-100 tw-border tw-border-red-400 tw-text-red-700 tw-rounded"
    *ngIf="error"
  >
    <p>{{ error }}</p>
  </div>
</div>
